import { Box, Tag } from '@factorialco/deprecated-design-system'
import { ProjectionKind, usePastCoursesDatatable } from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import { TrainingMembershipStatusTag } from 'modules/trainings/components/Shared/TrainingMembershipStatusTag'

import { courseStatusFilter } from './Filters/courseStatusFilter'
import { startDateFilter } from './Filters/startDateFilter'

export const PastCoursesSidepanel: React.FC<{
  open: boolean
  onClose: () => void
  targetAccessId: string
}> = ({ open, onClose, targetAccessId }) => {
  const source = usePastCoursesDatatable(
    [
      {
        identifier: 'name',
        kind: ProjectionKind.Path,
        title: i18n.t('performance_process.targets.see_past_courses.course_column_name'),
        path: 'name',
        colSpan: 3,
      },
      {
        identifier: 'competencies',
        kind: ProjectionKind.Custom,
        render: ({ competencies }) => {
          return (
            <Box gap="s4" flexDirection="row" flexWrap="wrap">
              {competencies.map((competency, index) => (
                <Tag type="viridian" key={index}>
                  {competency.name}
                </Tag>
              ))}
            </Box>
          )
        },
        title: i18n.t('performance_process.targets.see_past_courses.competencies_column_name'),
        template: '{{ training.name }}',
        colSpan: 2,
      },
      {
        identifier: 'attendanceStatus',
        kind: ProjectionKind.Custom,
        render: ({ trainingAttendanceStatus }) => (
          <TrainingMembershipStatusTag status={trainingAttendanceStatus} />
        ),
        template: '{{ attendanceStatus }}',
        title: i18n.t('performance_process.targets.see_past_courses.status_column_name'),
        colSpan: 2,
      },
    ],
    {
      variables: {
        accessId: targetAccessId,
      },
    }
  )

  return (
    <Sidepanel
      open={open}
      onClose={onClose}
      width="wideXL"
      title={i18n.t('performance_process.targets.see_past_courses.title_panel')}
    >
      <DataTable
        disableEditColumns
        disableExport
        pagination={{ kind: 'offset', itemsPerPage: 10 }}
        source={source}
        filters={[startDateFilter(source), courseStatusFilter(source)]}
        sort={{ path: 'status', direction: 'asc' }}
      />
    </Sidepanel>
  )
}
